import { useSelector } from "react-redux";
import ProjectEditorV1 from "./ProjectEditorV1";
import ProjectEditorV2 from "./ProjectEditorV2";
import { isMobile } from 'react-device-detect';
import React, { useEffect } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Cancel, Save, WarningAmber } from "@mui/icons-material";

function ProjectEditor() {
    const projectData = useSelector((state) => state.project.selectedProject);

    //const isMobile = 1; //for testing purposes
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [aborted, setAborted] = React.useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (!projectData) return;
        if (isMobile) {
            const nrOfUniqueObjects = projectData?.model?.binaries?.length || 0;
            const nrOfTextures = projectData?.model?.textures?.length || 0;

            if (!projectData?.model?.gltf) {
                setDialogOpen(true);
            }

            if (nrOfUniqueObjects >= 300) {
                setDialogOpen(true);
            }

            if (nrOfUniqueObjects + nrOfTextures >= 2500) {
                setDialogOpen(true);
            }
        }
    }, [isMobile, projectData]);

    const handleCancel = () => {
        setDialogOpen(false);
        setAborted(true);
    };

    const handleContinue = () => {
        setDialogOpen(false);
    };

    const renderWarningDialog = () => {
        return (
            <Dialog open={dialogOpen}>
                <DialogTitle style={{ fontWeight: 'bold' }}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <WarningAmber sx={{ color: '#facc15' }} />{t('Warning title')}
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {t('Warning description')}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} startIcon={<Cancel />} color="error" variant="contained" size="small">
                        {t('Abort')}
                    </Button>
                    <Button onClick={handleContinue} startIcon={<Save />} color="success" variant="contained" size="small">
                        {t('Continue')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    if (dialogOpen && !aborted) {
        return renderWarningDialog();
    }

    if (!isMobile) {
        return projectData && (
            projectData.models && projectData.models.length != 0
                ? <ProjectEditorV2 />
                : <ProjectEditorV1 />
        );
    } else {
        return projectData && (
            projectData.model && projectData.model.gltf
                ? <ProjectEditorV1 abort={aborted} />
                : <ProjectEditorV2 abort={aborted} />
        )
    }
}

export default ProjectEditor;
